/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect, useContext } from 'react';
import useCarsData from '../../hooks/useCarsData';
import CurrencyFormat from './CurrencyFormat';
import { CotizadorContext } from '../../context';

const MaterialSelect = (props) => {
    const [state] = useContext(CotizadorContext);
    const { cars, getSelectedCar } = useCarsData();
    const { defaultText, isModal } = props;

    const containerRef = useRef(null);
    
    const [selectActive, setSelectActive] = useState(false);
    const [selectedCar, setSelectedCar] = useState(props.selectedCar);

    const selectCar = car => {
        if (props.onCarSelect) {
            props.onCarSelect(car);
        }
        setSelectedCar(car);
        setSelectActive(false);
    };

    // Sincronizar con el estado global cuando se cargan los autos o cambia la selección
    useEffect(() => {
        const globalSelectedCar = getSelectedCar();
        if (globalSelectedCar) {
            setSelectedCar(globalSelectedCar);
        }
    }, [cars, state.selected_car]); // Observar state.selected_car directamente

    /**
     * manejo de click afuera del elemento para cerrar el select
     */
    const handleOutsideClick = e => {
        if (containerRef && !containerRef.current.contains(e.target)) {
            setSelectActive(false);
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick, true);
        return () => {
            document.removeEventListener('click', handleOutsideClick, true);
        }
    }, []);

    return (
        <div ref={containerRef}>
            <div className="form-group-cotizador car-list">
                <div
                    className={
                        "form-control material-select " +
                        (selectedCar ? "bold" : "")
                    }
                    onClick={() => setSelectActive(!selectActive)}
                >
                    {selectedCar ? selectedCar.name : defaultText}
                </div>
                <ul className={selectActive ? "active" : ""}>
                    {cars.map(car => (
                        <li
                            key={car.id}
                            onClick={() => selectCar(car)}
                            className={isModal ? "is-modal" : ""}
                        >
                            {/* <div className="thumb-select-car">
                                <img src={car.photo_1.url} alt={car.name}></img>
                            </div> */}
                            <div className="info-select-car">
                                <h4 className="title4">{car.name}</h4>
                                <small>
                                    Cuota mensual desde <CurrencyFormat value={car.months_36_rate} /> por 36 meses*
                                </small>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );

}

MaterialSelect.defaultProps = {
    selectedCar: null
};

export default MaterialSelect;